import React, {useEffect, useRef, useState, lazy, Suspense, useCallback} from 'react';
import Products from './Products';
import FeatureContext from './FeatureContext';
import ProductSlider from './ProductSlider';
import { useLocation, useParams, useNavigate, Link} from 'react-router-dom';
import { changeProdiuctView } from './CustomHook';
import { vibrateMobileDevice, RippleEffect, capitalizeFirst, timeForPage } from './UtilsFunction';
// import Explore from './Explore';


import AppPagesHeading from './AppPagesHeading';
import Blogs from './Blogs';
import { Helmet } from 'react-helmet';
import "./Home.css";
import ExploreMasonry from './ExploreMasonry';
import {trackEvent} from "./UtilsFunction"
import { AppStatusElement } from './AppStatusElement';

import ScrollTag from './ScrollTag';
import { StatusDownloadCard } from './StatusDownloadCard';
import CaptionIdeas from './CaptionIdeas';


// const HOME_TOPICS = [
//   {
//     key: "sunset",
//     title: "Sunset Moments",
//     subtitle: "Discover peaceful moments",
//     query: "sunset",
//   },
//   {
//     key: "flower",
//     title: "Life Moments",
//     subtitle: "Discover peaceful life moments",
//     query: "flower",
//   },
//   {
//     key: "beach",
//     title: "Beach & Ocean Vibes",
//     subtitle: "Find your next escape",
//     query: "beach",
//   },
//   {
//     key: "mountains",
//     title: "Mountain Inspiration",
//     subtitle: "Explore the great outdoors",
//     query: "mountains",
//   },
//   {
//     key: "love",
//     title: "Love & Couple Moments",
//     subtitle: "Discover moments worth sharing",
//     query: "love",
//   },
//   {
//     key: "travel",
//     title: "Travel Inspiration",
//     subtitle: "Find places worth dreaming about",
//     query: "travel",
//   },
// ];


const HOME_TOPICS = [
  {
    key: "love",
    // title: "Couples Moments for Your Next Post",
    title: "Pick Photos for your Love Post",
    subtitle: "Discover moments worth sharing",
    // subtitle: "Find an image for your next romantic post",
    query: "love couple",
    
    // query: "intimate%20moment%20of%20a%20couple%20holding%20hands",
  },

  {
    key: "diwali",
    title: "Diwali Coming Soon",
    subtitle: "Find festive inspiration to celebrate & share",
    query: "diwali",
  },
  
  {
    key: "family",
    title: "Family Moments",
    subtitle: "Discover moments that bring people together",
    query: "family",
  },
  {
    key: "travel",
    title: "Travel Moments",
    subtitle: "Discover places and moments worth remembering",
    query: "travel",
  },
    {
    key: "nature",
    title: "Peaceful Nature Moments",
    // subtitle: "Discover moments of calm and beauty",
    subtitle: "Find a beautiful nature scene for your Status or Post",
    query: "peaceful nature movements",
    // query: "sunset-sea-beach-waves-sun-coast",
    // query: "church-slovenia-landscape-sunset",
    // query: "church-slovenia-landscape-sunset",
    // query: "sunset-sea-beach-waves-sun-coast",
  },

  {
    key: "home-decor",
    title: "Home & Decor",
    subtitle: "Make your home special",
    query: "home decor",
  },

  // {
  //   key: "celebration",
  //   title: "Celebration Moments",
  //   subtitle: "Discover moments worth celebrating",
  //   query: "celebration",
  // },
  
  {
    key: "wallpaper",
    title: "Wallpaper Collections",
    subtitle: "Discover wallpaper worth saving",
    query: "wallpaper",
  },
];


// const HOME_IMAGE_CHIPS = [
//   "Love",
//   "Family",
//   "Travel",
//   "Beach",
//   "Sunset",
//   "Nature",
//   "Flowers",
//   "Mountains & Adventure",
//   "Home & Decor",
//   "Celebration",
// ];


const HOME_IMAGE_CHIPS = [
  "Nail Art",
  "Women's Fashion",
  "Men's Fashion",
  // "Outfit Ideas",
  "Wedding",
  // "Bridal Looks",
  // "Makeup",
  "Hairstyles",
  // "Jewelry",
  "Home Decor",
  // "Food Ideas",
  "Travel",
    "Flowers",
    "wallpapers"
  // "Mountains & Adventure",
];

// function getLastExploredCategory(limit = 3) {  
//    const lastExplored = localStorage.getItem("lastExploredCategory");

//   if (!lastExplored) return [];

//  return [lastExplored];    
// }


function getLastExploredCategory() {  
  return localStorage.getItem("lastExploredCategory");
}



function getSessionInteractions() {
  return JSON.parse(sessionStorage.getItem("sessionInteraction") || "{}");
}

function getTopExploredCategories(limit = 3) {
  const stored = JSON.parse(localStorage.getItem("interactionScore") || "{}");
  const session = getSessionInteractions();

  const merged = {};

  // long-term base
  Object.keys(stored).forEach(cat => {
    merged[cat] = stored[cat];
  });

  // session boost (stronger, but temporary)
  Object.keys(session).forEach(cat => {
    merged[cat] = (merged[cat] || 0) + session[cat] * 2;
  });

  return Object.entries(merged)
    .sort((a, b) => b[1] - a[1])
    .slice(0, limit)
    .map(([category]) => category);
}






function filterImagesByCategory(images, category, limit = 10) {
  return images
    .filter(img =>
      img.tags?.toLowerCase().includes(category.toLowerCase())
    )
    .slice(0, limit);
}







const DeskTopHeadings = [
  // "Fresh Finds Waiting for You ⏰",
  "Fresh Finds Waiting for You",
  "Come Back Every Hour for Fresh Finds",
  "Discover What’s New Right Now",
  // "Trending Now: See What’s Hot 🔥 ",
  "Trending Now: See What’s Hot",
]
// const MobileHeadings = [
//   "Fresh Images ⏰",
//   "Discover New",
//   "Come Back Often",
//   "Trending 🔥"
// ];

const MobileHeadingses = [
  "🔥 Must-See!",
  "⏰ Just In!",
  "👀 Can’t Miss!",
  "✨ Hot Picks!",
  "💎 Hidden Gems",
  "⚡ Trending Now",
  "🎯 Top Finds",
  "🌟 New & Rare",
  "🚀 Explore Now",
  "🎉 Today’s Hits",



  "New Hot Images 🔥",
  "Fresh Visuals Every Hour ⏰",
  "Discover Favorite Images 👀",
  "Trending Now: Don’t Miss Out"
];

const MobileHeadings = [
// "Just in ⏰",
//  "Top Finds 🎯",
//  "Hot Picks ✨",
//  "Can’t Miss 👀"
"Just in ",
 "Top Finds ",
 "Hot Picks ",
 "Can’t Miss "
  
];
const subTitlesForSavedFeeds = [
"Most-loved picks from users",
"See what everyone’s saving right now",
"Discover what’s catching attention",
"Popular images people saved now!",
"What others found worth saving",

"Images people loved the most",
"Trending saves from users",
"Recently saved by others",
"Inspired by what people save",
"Saved and shared by the community",
  
];

// const buttonTextForSavedOthers = [
//  "See What’s Trending",
//   "Explore What Others Love",
//   "Discover Popular Picks",
//   "Join the Hype",
//   "Find Your Next Favorite",
//   "Get Inspired by Others",
//   "Explore Viral Finds",
//   "Browse the Hottest Saves",
//   "See What’s Hot Right Now",
//   "Dive Into Creative Trends",
// ];

const buttonTextForSavedOthers = [
  "See what’s trending",
  "Explore what others love",
  "Discover popular picks",
  "Join the hype",
  "Find your next favorite",
  "Get inspired by others",
  "Explore viral finds",
  "Browse the hottest saves",
  "See what’s hot right now",
  "Dive into creative trends",
];


// const buttonTextForFreshFinds = [
//   "See What’s New",
//   "Discover Fresh Picks",
//   "Explore the Latest Drops",
//   "Find Something New",
//   "Uncover Today’s Inspiration",
//   "Check Out What’s Fresh",
// ];

const buttonTextForFreshFinds = [
  "See what’s new",
  "Discover fresh picks",
  "Explore the latest drops",
  "Find something new",
  "Uncover today’s inspiration",
  "Check out what’s fresh",
];


export default function Home(props) {
  const [SliderHeading, setSliderHeading] = useState("Choose Your Favourite");
  const location = useLocation();
  const [productView, setProductView] = useState("productView")
  const [url, setUrl]= useState(location.pathname)
  const [currentHeading, setCurrentHeading] = useState(0);
  const buttonRef = useRef(null)
  const [featuredStoredImage, setFeatureStoredImage] = useState([])   // for the feature section images loading state (top first section)
  const [initialLoadedImageses, setInitailoadedImages] = useState([])     // for explore instant Loading the images
  const [lastUpdatedTime, setLastupdatedTime] = useState(new Date().toISOString())
  const [suggestedState, setSuggestedState] = useState(null)       // for seting the current suggested object
  const [categoryImageCount, setCategoryImageCount] = useState({});  

  // below code for last image category section Starts Below  
  let lastExploredCategory = getLastExploredCategory()

  // below code for Continue Exploreing SECTION Starts Below    
  const exploredCategories =  getTopExploredCategories(2).filter(
  cat => cat !== lastExploredCategory
); ;

const hasAnyPersonalizedImages = exploredCategories.some(category =>
  categoryImageCount[category] !== undefined &&
  categoryImageCount[category] > 0
);
const finalExploredCategories = hasAnyPersonalizedImages ? exploredCategories.filter(
      category => (categoryImageCount[category] ?? 0) > 0
    ).slice(0, 1)
  : exploredCategories;
  const [homeStatusPack, setHomeStatusPack] = useState([]);

// const homeTopicQueries = HOME_TOPICS.map(topic => topic.query);


// below code for Continue Exploreing SECTION End Above


  // useEffect(()=>{
  //   // topic= "Home"
  //   document.title = "Explore Images & Captions for Creators | BrowseNext "
  //   console.log("featuredStoredImagein hom", featuredStoredImage)
    
  // })

  // function rotateDeskTopHeading(arrayHeading){
  //    const hour = new Date().getHours();
  //   const index = hour % arrayHeading.length;
  //   setCurrentHeading(index);
    
    
  //   const now = new Date();
  // const msUntilNextHour = (60 - now.getMinutes()) * 60 * 1000 - now.getSeconds() * 1000 - now.getMilliseconds();
  //   // const msUntilNextHour = 1000;
  
  //   const timeout = setTimeout(() => {
  //     setCurrentHeading((prev) => (prev + 1) % arrayHeading.length);
  //     const interval = setInterval(() => {
  //       setCurrentHeading((prev) => (prev + 1) % arrayHeading.length); 
     
  //     }, 60 * 60 * 1000); 
  //     // },  1000); 
      
  //   }, msUntilNextHour);
  
  //   return () => {
  //     clearTimeout(timeout);
      
  //   };
  // }

  function rotateDeskTopHeading(arrayHeading, setFn) {
  const hour = new Date().getHours();
  const index = hour % arrayHeading.length;
  setFn(index);

  const now = new Date();
  const msUntilNextHour =
    (60 - now.getMinutes()) * 60 * 1000 -
    now.getSeconds() * 1000 -
    now.getMilliseconds();

  const timeout = setTimeout(() => {
    setFn((prev) => (prev + 1) % arrayHeading.length);
    const interval = setInterval(() => {
      setFn((prev) => (prev + 1) % arrayHeading.length);
    }, 60 * 60 * 1000);
  }, msUntilNextHour);

  return () => clearTimeout(timeout);
}
const [currentSubtitleForSaved, setCurrentSubtitleForSaved] = useState(0);
const [buttonText, setButtonText] = useState(0)
const [buttonTextForFreshFind, setButtonTextForFreshFinds] = useState(0)
   useEffect(() => {
    // Set heading based on current hour
  //  rotateDeskTopHeading(DeskTopHeadings)
   rotateDeskTopHeading(DeskTopHeadings, setCurrentHeading)
   rotateDeskTopHeading(MobileHeadings, setCurrentHeading)
    rotateDeskTopHeading(subTitlesForSavedFeeds, setCurrentSubtitleForSaved);
    rotateDeskTopHeading(buttonTextForSavedOthers, setButtonText);
    rotateDeskTopHeading(buttonTextForFreshFinds, setButtonTextForFreshFinds);
  
  }, []);
  

 function sendClickFeed(event , element){    
    let shareButton = event.target;
    console.log("this", element)
    console.log("document.title in home", featuredStoredImage)
    if(shareButton){
      buttonRef.current.style.backgroundColor = "#000000b8";
      // shareButton.firstElementChild.style.color = "white";
      shareButton.style.transition = "all 0.05s linear";
      shareButton.style.transform = "scale(0.9)";
      
      // shareButton.firstElementChild.style.backgroundColor = "white";
    }
    
  }
  function removeClickFeed(event){    
    let shareButton = event?.target;

    if(shareButton){
      buttonRef.current.style.backgroundColor = "black";
      shareButton.style.transform = "scale(1)";
      // shareButton.firstElementChild.style.color = "";
      // shareImage(imageUrl)
          // showBlog();
          // shareButton.style.backgroundColor = "";
      
    }
    
  }
  function orignalElement(event){
    let shareButton = event?.target;
    if(shareButton){
      buttonRef.current.style.backgroundColor = "black";
      shareButton.style.transform = "scale(1)";
      // shareButton.firstElementChild.style.color = "";         
    }    
  }
  

  function ExploreHeading(props){

      const [isMobile, setIsMobile] = useState(window.innerWidth <= 580);
    
    useEffect(() => {
      const onResize = () => setIsMobile(window.innerWidth <= 580);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }, []);


function getLastUpdatedText(lastUpdatedTime) {
  // 0–15 min → Updated just now 🔥
  if (lastUpdatedTime >= 0 && lastUpdatedTime <= 15) {
    return "Updated just now";
  }

  // 45–59 min → Just updating in — X min left ⏳
  if (lastUpdatedTime >= 45 && lastUpdatedTime <= 59) {
    return `New images arriving in ${60 - lastUpdatedTime} min`;
  }

  // Everything else → Last updated at X min ago
  return `Last updated ${lastUpdatedTime} min ago`;
}


    return(
      <>
  <div className={`explore_home_heading_container app_container app_explore_home_feeds ${(props.forWhich === "personalized") ? 'mt-3 personal' : "mt-3" }`}>
<div className="app_left_elmenets">
<div className='home_heading_updates d-flex flex-column'>
 <div className='app_home_feeds_heading desktop_heading'>{props.deskTopHeading}</div>
 <div className={`app_home_feeds_heading ${(props.forWhich === "personalized" || props.forWhich === "lastExplored") ? 'short_mobile_heading' : " mobile_heading" }`}>{props.mobileHeading}</div>


{(() => {
  if (props.forWhich === "personalized") {
    return (
      <span className="last_updated_text blog_back_heading">
        {props.homeNew === true ? `${props.continousTopic}` : 'Inspired by your recent activity'}
         {/* Continue where you left off  */}
        {/* Because you explored {props.categoryName} images already */}

      </span>
    );
  }
  if (props.forWhich === "lastExplored") {
    return (
      <span className="last_updated_text blog_back_heading">
        {/* Inspired by your recent activity */}
         {/* Continue where you left off  */}
        {/* Because you explored {props.categoryName} images already */}        
        {/* Because you viewed {props.categoryName} images */}
       {/* More {props.categoryName} images for you */}
        {/* More {props.categoryName} images you might like  */}
        
        You was exploring {props.categoryName} images

      </span>
    );
  }


  if (props.forWhich === "SuggestedFeeds") {
    return (
      <span className="last_updated_text">
        {/* Images updated every hour */}
        {getLastUpdatedText(lastUpdatedTime)}
      </span>
    );
  }

  if (props.forWhich === "HomeFeeds") {
    return (
      <span className="last_updated_text">
        {getLastUpdatedText(lastUpdatedTime)}
      </span>
    );
  }

  return (
    <span className="last_updated_text">
      {subTitlesForSavedFeeds[currentHeading]}
    </span>
  );
})()}







 {/* {props.forWhich === "HomeFeeds" && <span className='last_updated_text'>Last updated at {lastUpdatedTime}min ago</span>} */}
    
 </div>


</div>

         {(!isMobile || (props.forWhich !== "lastExplored" && props.forWhich !== "personalized")) && (
          <>
             <Link className="app_explore_see_all"
          
         
           to={(props.forWhich === "personalized" || props.forWhich === "lastExplored") ? `/explore-next/photo/${encodeURIComponent(props.categoryName)}` : "/explore"}
           draggable={false} ref={buttonRef}   onMouseDown={(e)=>sendClickFeed(e)} onMouseUp={(e)=>removeClickFeed(e)} onMouseOut={(e)=>orignalElement(e)}
           onTouchStart={(e) => sendClickFeed(e)}
  onTouchEnd={(e) => removeClickFeed(e)}
  onTouchCancel={(e) => orignalElement(e)}
          
          >
          {props.forWhich === "personalized" ? <ButtonText /> : "See all"} <i className="fa-solid fa-angle-right home_seeall_icon"></i>

          </Link>
          </>
         )}

</div>
      </>
    )
  }

//   function shouldShowAppStatusElement() {
//   const hideDiscoveryNote =
//     localStorage.getItem("hideDiscoveryNote") === "true";

//   const interactionScore =
//     JSON.parse(localStorage.getItem("interactionScore") || "{}");

//   const savedImages =
//     JSON.parse(localStorage.getItem("savedImages") || "[]");

//   const hasInteraction = Object.keys(interactionScore).length > 0;
//   const hasSavedImages = savedImages.length > 0;

//   return (!hideDiscoveryNote && !hasInteraction && !hasSavedImages
//   );
// }

const [showAppStatus, setShowAppStatus] = React.useState(false);
const [storageReady, setStorageReady] = React.useState(false);

useEffect(() => {
  const hideDiscoveryNote =
    localStorage.getItem("hideDiscoveryNote") === "true";

  const interactionScore =
    JSON.parse(localStorage.getItem("interactionScore") || "{}");

  const savedImages =
    JSON.parse(localStorage.getItem("savedImages") || "[]");

  const hasInteraction = Object.keys(interactionScore).length > 0;
  const hasSavedImages = savedImages.length > 0;

  const shouldShow =
    !hideDiscoveryNote && !hasInteraction && !hasSavedImages;

  setShowAppStatus(shouldShow);
  setStorageReady(true);
}, []);


const navigate = useNavigate();

function trackChipClick(tag, index) {
  if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true") return;

  const pageName = "exploreNext";

  trackEvent(`chip_click_${pageName}`, {
    clicked_tag: tag,
    chip_position: index,
    page_path: window.location.pathname,
    // current_query: props.displayImage || "unknown",
  });
}

function handleTagClick(tag, index) {
  
  trackChipClick(tag, index)


  // displayImage.imageTag = tag
    navigate(`/explore-next/photo/${encodeURIComponent(tag)}`);

}

const statusImagesRef = useRef({});
const [statusPack, setStatusPack] = useState([]);

const collectStatusImages = useCallback((category, images) => {
  if (!Array.isArray(images) || images.length === 0) return;

  statusImagesRef.current[category] = images;

  const groups = statusImagesRef.current;

  // Wait until both priority feeds have reported images.
  if (!groups.love?.length || !groups.nature?.length) {
    return;
  }

  const unique = (items) => {
    const seen = new Set();

    return items.filter((img) => {
      const id = img._uid || img.id || img.webformatURL;
      if (!id || seen.has(id)) return false;

      seen.add(id);
      return true;
    });
  };

  const love = unique(groups.love);
  const nature = unique(groups.nature);

  const others = unique(
    Object.entries(groups)
      .filter(([key]) => key !== "love" && key !== "nature")
      .flatMap(([, items]) => items)
  );

  // Reserve the requested category slots.
  const selected = [
    ...love.slice(0, 3),
    ...nature.slice(0, 3),
  ];

  const used = new Set(
    selected.map((img) => img._uid || img.id || img.webformatURL)
  );

  const remaining = others.filter(
    (img) => !used.has(img._uid || img.id || img.webformatURL)
  );

  selected.push(...remaining.slice(0, 2));

  // Shuffle only after category selection.
  for (let i = selected.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [selected[i], selected[j]] = [selected[j], selected[i]];
  }

  setStatusPack(selected.slice(0, 8));
  console.log(
  "Status pack category received:",
  category,
  images.length
);
}, []);

useEffect(() => {
  console.log(
    "FINAL STATUS PACK:",statusPack,
    statusPack.map((img) => ({
      id: img.id,
      tags: img.tags,
      category: img._category,
    }))
  );
}, [statusPack]);

const sections = [
  ["initial_explore", "home-section-initial-explore"],
  ["continue_exploring", "home-section-continue-exploring"],
  ["because_you_explored", "home-section-because-you-explored"],
  ["love", "home-section-love"],
  ["diwali", "home-section-diwali"],
  ["family", "home-section-family"],
  ["travel", "home-section-travel"],
  ["nature", "home-section-nature"],
  ["home_decor", "home-section-home-decor"],
  ["wallpapers", "home-section-wallpaper"],
  ["saved_by_others", "home-section-savedbyother"],
  ["suggested_for_you", "home-section-SuggestedFeeds"],
];

useEffect(() => {
  const sections = [
    ["initial_explore", "home-section-initial-explore"],
    ["continue_exploring", "home-section-continue-exploring"],
    ["because_you_explored", "home-section-because-you-explored"],
    ["love", "home-section-love"],
    ["diwali", "home-section-diwali"],
    ["family", "home-section-family"],
    ["travel", "home-section-travel"],
    ["nature", "home-section-nature"],
    ["home_decor", "home-section-home-decor"],
    ["wallpapers", "home-section-wallpaper"],
    ["saved_by_others", "home-section-savedbyother"],
    ["suggested_for_you", "home-section-SuggestedFeeds"],
     ["love_captions", "home-caption-love"],
  ["nature_captions", "home-caption-nature"],
     ["download_status", "home-download-status"],
  ];

  const reachedSections = new Set();

  const handleScroll = () => {
    const viewportBottom = window.innerHeight;

    sections.forEach(([sectionName, elementId]) => {
      if (reachedSections.has(sectionName)) return;

      const element = document.getElementById(elementId);
      if (!element) return;

      const top = element.getBoundingClientRect().top;

      if (top < viewportBottom && top + element.offsetHeight > 0) {
        reachedSections.add(sectionName);
// console.log("home_section_reached", sectionName)
        trackEvent("home_section_reached", {
          section_name: sectionName,
          deviceWidth: timeForPage(),
        });
      }
    });
  };

  window.addEventListener("scroll", handleScroll, {
    passive: true,
  });

  handleScroll();

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

const [loadedSections, setLoadedSections] = useState(
  () => new Set(["initial-explore"])
);

useEffect(() => {
  const sectionIds = [
     "home-section-continue-exploring",
    "home-section-love",
    "home-section-diwali",
    "home-section-family",
    "home-section-travel",
    "home-section-nature",
    "home-section-home-decor",
    "home-section-wallpaper",
    "home-section-savedbyother",
    "home-section-SuggestedFeeds",
   "home-section-because-you-explored"
    
  ];

  const observer = new IntersectionObserver(
    (entries) => {
      const sectionsToLoad = entries
        .filter((entry) => entry.isIntersecting)
        .map((entry) => entry.target.dataset.sectionKey);

      if (sectionsToLoad.length > 0) {
        setLoadedSections((previous) => {
          const next = new Set(previous);
          sectionsToLoad.forEach((key) => next.add(key));
          return next;
        });
      }
    },
    {
      rootMargin: "700px 0px",
      threshold: 0,
    }
  );

  sectionIds.forEach((id) => {
    const element = document.getElementById(id);

    if (element) {
      observer.observe(element);
    }
  });

  return () => observer.disconnect();
}, []);
  

  return (
    <>

     <Helmet>
      <title>Explore Images & Captions for Creators | BrowseNext</title>

      <meta
        name="description"
        content="Explore free images, captions, hashtags, and creative tools on BrowseNext."
      />

      <link
        rel="canonical"
        href="https://www.browsenext.today/"
      />
    </Helmet>


 {/* mt-ps90 */}
    <div id={productView} className='container app_container max-width-full'>

{/* <ScrollTag whereFrom="exploreNext" tagList={HOME_IMAGE_CHIPS}  onTagClick={handleTagClick}  /> */}

    
   {/* {shouldShowAppStatusElement() && <AppStatusElement />} */}

   {/* {storageReady && showAppStatus && <AppStatusElement />} */}

   
{/* <FeatureContext displayedFeaturedImages={featuredStoredImage}   /> */}


{/* <div className="app_divider"/> */}

{/* for the HomeExploreFeed view  Starts*/}

{/* <ExploreHeading forWhich="HomeFeeds" deskTopHeading={DeskTopHeadings[currentHeading]} mobileHeading={MobileHeadings[currentHeading]} /> */}

{/* <Explore componentFrom="home" /> */}
{/* <Suspense fallback={<div>Loading Explore...</div>}> */}
 {/* </Suspense> */}
<div id="home-section-initial-explore">
  <ExploreMasonry componentFrom="home" displayFor="forExplore" featurStoredImage={setFeatureStoredImage} lastUpdatedAt={setLastupdatedTime} 
   setCurrentObj={setSuggestedState} suggestedObjectClickedValue={suggestedState} 
   instantLoadForExplore={setInitailoadedImages}
   fetchSavedImages={props.fetchSavedImages} 
   

  //  onStatusPackReady={setHomeStatusPack}
    />
  
 
<ExploreLinkButton buttonText={buttonTextForFreshFinds[buttonTextForFreshFind]} buttonType="explore"  initialImages={initialLoadedImageses}  />
</div>
<div className="app_divider"/>
{/* Added new Status Section Start Here ------------------------------------------------*/}

 {/* {homeStatusPack.length > 0 && (
  <StatusDownloadCard
    images={homeStatusPack}
    imageCategoryName={"Trending"}
  />
)} 
<div className="app_divider"/> */}

{/* Added new Status Section end above ------------------------------------------------*/}


{/* for the HomeExploreFeed view  End*/}

{/* Start Below User last explored image category*/}
{lastExploredCategory && (
  (() => {
    const imageCount = categoryImageCount[lastExploredCategory];

    // hide only if we KNOW it's zero
    if (imageCount === 0) return null;

    return (
      <React.Fragment key={`continue-${lastExploredCategory}`}>
        <div id={`home-section-continue-exploring`}   data-section-key="continue-exploring">
        <ExploreHeading
          forWhich="lastExplored"
          // deskTopHeading="Beacuse You Explored"
          // mobileHeading="Beacuse You Explored"

        deskTopHeading={`Continue Exploring`}  
        mobileHeading={`Continue Exploring`}  

          categoryName={lastExploredCategory}
        />

        <ExploreMasonry
          componentFrom="home"
          displayFor="personalized"
          forcedCategory={lastExploredCategory}
          featurStoredImage={setFeatureStoredImage}
          fetchSavedImages={props.fetchSavedImages}
          lastUpdatedAt={setLastupdatedTime}
          setCurrentObj={setSuggestedState}
          suggestedObjectClickedValue={suggestedState}
          onImagesLoaded={(count) => {
            setCategoryImageCount(prev => ({
              ...prev,
              [lastExploredCategory]: count
            }));
          }}
             enabled={loadedSections.has("continue-exploring")}
        />

        {imageCount > 0 && (
          <>
            <ExploreLinkButton
              buttonText={`More images waitings`}
              buttonType="userchoice"
              category={lastExploredCategory}
            />
            <div className="app_divider" />
          </>
        )}
        </div>
      </React.Fragment>
    );
  })()
)}

{/* End above  User last explored image category*/}

{/* Start Below User explored section*/}

{finalExploredCategories.map((category, index) => {
  const imageCount = categoryImageCount[category];
    const sectionKey = `because-you-explored-${index}`;
  // ❌ hide ONLY if confirmed zero
  if (imageCount === 0 ) return null;

  return (
    <React.Fragment key={category} >
      <div  id="home-section-because-you-explored"      data-section-key={"home-section-because-you-explored"}>
      <ExploreHeading
        forWhich="personalized"
        // deskTopHeading={`Because you explored ${capitalizeFirst(category)} images`}       
        deskTopHeading={`Because You Explored`}  
        // deskTopHeading={`Continue Exploring`}  
        categoryName={category}             
        // mobileHeading={`${capitalizeFirst(category)} images you explored`}
        mobileHeading={`Because You Explored`}
        
      />

      <ExploreMasonry
        componentFrom="home"
        displayFor="personalized"
        forcedCategory={category}
        featurStoredImage={setFeatureStoredImage}
        fetchSavedImages={props.fetchSavedImages}
        lastUpdatedAt={setLastupdatedTime}
        setCurrentObj={setSuggestedState}
        suggestedObjectClickedValue={suggestedState}

        // 🔥 THIS IS THE IMPORTANT PART
        onImagesLoaded={(count) => {
          setCategoryImageCount(prev => ({
            ...prev,
            [category]: count
          }));
        }}
                enabled={loadedSections.has("home-section-because-you-explored")}
      />

      {imageCount > 0 && (
        <>
          <ExploreLinkButton
            // buttonText={`Explore More ${capitalizeFirst(category)} image`}
            buttonText={`Continue exploring ${category} images`}
            // buttonText={`More ${category} images waiting`}
            
            buttonType="userchoice"
            category={category}
          />
          <div className="app_divider" />
        </>
      )}
      </div>
    </React.Fragment>
  );
})}

{/* End above User explored section*/}

{/* Iniftnite explore secroll section starts here..................................*/}
{HOME_TOPICS.map((topic) => {
 const imageCount = categoryImageCount[topic.query];
  
  // ❌ hide ONLY if confirmed zero
  if (imageCount === 0 ) return null;

 return(
    <React.Fragment key={topic.key} >
<div id={`home-section-${topic.key}`}   data-section-key={topic.key} >
   
      <ExploreHeading
        forWhich="personalized"
            
        deskTopHeading={topic.title}  
          
        categoryName={topic.query}             
        
        mobileHeading={topic.title}
        homeNew={true}
        continousTopic={topic.subtitle}
        
      />

    <ExploreMasonry
      componentFrom="home"
      displayFor="homeTopic"
      forcedCategory={topic.query}
      homeTopicKey={topic.key}
      featurStoredImage={setFeatureStoredImage}
      lastUpdatedAt={setLastupdatedTime}
      setCurrentObj={setSuggestedState}
      suggestedObjectClickedValue={suggestedState}
      fetchSavedImages={props.fetchSavedImages}
        onImagesLoaded={(count) => {
            setCategoryImageCount(prev => ({
              ...prev,
              [topic.query]: count
            }));
          }}
         onStatusPackReady={(images) =>
  collectStatusImages(
    topic.key,
    images.map((img) => ({
      ...img,
      _statusSourceCategory: topic.key,
    }))
  )
}
    enabled={loadedSections.has(topic.key)}

    />

     
          {/* <div className="app_divider" /> */}

{imageCount > 0 && (
        <>
          <ExploreLinkButton
            // buttonText={`Explore More ${capitalizeFirst(category)} image`}
            // buttonText={`Continue exploring ${topic.query} images`}
            buttonText={`Explore similar images`}
            // buttonText={`More ${category} images waiting`}
            
            buttonType="userchoice"
            category={topic.query}
          />
          <div className="app_divider" />
        </>
      )}
      </div>


      {(topic.key === "love" || topic.key === "nature") && (<>
      <div id={`home-caption-${topic.key}`} >
        {/* className='bg_color_container' */}
        <CaptionIdeas category={topic.key} componentFrom="home" />
          <ExploreLinkButton
            // buttonText={`Explore More ${capitalizeFirst(category)} image`}
            // buttonText={`Continue exploring ${topic.query} images`}
            buttonText={`Explore all ${topic.key === "love" ? "Love" : "Nature"}  Captions`}
            // buttonText={`More ${category} images waiting`}
            buttonFor = "captions"
            buttonType="captions"
            category={topic.key}
          />
      </div>
          <div className="app_divider" />
      </>
)}
   
   

  </React.Fragment>
 )
}
)}

{/* <ExploreLinkButton
  buttonText={`Continue exploring ${topic.query} images`}
  buttonType="userchoice"
  category={topic.query}
/> */}
{/* <React.Fragment key={homeTopicQueries}>

   
      <ExploreHeading
        forWhich="personalized"
            
        deskTopHeading={"BrowseNext Trending Photos"}  
          
        // categoryName={topic.query}             
        
        mobileHeading={"BrowseNext Trending Photos"}
        homeNew={true}
        continousTopic={"Discover something new"}
        
      />


 <ExploreMasonry
      componentFrom="home"
      displayFor="homeTopic"
      forcedCategory={homeTopicQueries}

      featurStoredImage={setFeatureStoredImage}
      lastUpdatedAt={setLastupdatedTime}
      setCurrentObj={setSuggestedState}
      suggestedObjectClickedValue={suggestedState}
      fetchSavedImages={props.fetchSavedImages}
    />

</React.Fragment> */}


{/* Iniftnite explore secroll section end  above..................................*/}

{/* for the SavedByOthers view  Starts*/}
<div id={`home-section-savedbyother`} data-section-key="savedbyothers">

<ExploreHeading forWhich="SavedFeeds" deskTopHeading="Saved By Others" mobileHeading="Saved By Others" />
<ExploreMasonry componentFrom="home"  displayFor="forSavedOthers" featurStoredImage={setFeatureStoredImage} lastUpdatedAt={setLastupdatedTime} 
setCurrentObj={setSuggestedState}  suggestedObjectClickedValue={suggestedState}  
 
          
fetchSavedImages={props.fetchSavedImages}   enabled={loadedSections.has("savedbyothers")} />

<ExploreLinkButton buttonText={buttonTextForSavedOthers[buttonText]} buttonType="explore" />
 </div>
<div className="app_divider"/>
{/* for the SavedByOthers view  End*/}

{/* for the suggested view  Starts*/}
<div id={`home-section-SuggestedFeeds`}   data-section-key="suggested">

<ExploreHeading forWhich="SuggestedFeeds" deskTopHeading="Suggested for You" mobileHeading="Suggested for You" />
<ExploreMasonry componentFrom="home" displayFor="forSuggested" featurStoredImage={setFeatureStoredImage} lastUpdatedAt={setLastupdatedTime} 
setCurrentObj={setSuggestedState} suggestedObjectClickedValue={suggestedState} fetchSavedImages={props.fetchSavedImages}  enabled={loadedSections.has("suggested")} />
<ExploreLinkButton buttonText={`See more you’ll love`} buttonType="explore" forWhich={"SuggestedFeed"} />
</div>
<div className="app_divider"/>
{/* for the suggested view  End */}



{/* {(!hasAnyPersonalizedImages) && ( */}
  {/* <>
  
<Products componentFrom="home" />
<ExploreLinkButton  buttonText="Checkout more products" buttonType="product" />
<div className="app_divider"/>

  </> */}
{/* )


} */}

{/* <Blogs componentFrom="home" />
<ExploreLinkButton buttonText="Explore latest blogs " buttonType="blog" /> */}
   {/* sendClickFeed
          removeClickFeed
          orignalElement */}

          
{statusPack.length > 0 && (
  <div className="app_container google_user_container mb-4" id={`home-download-status`}>

    
    <StatusDownloadCard
      images={statusPack}
      imageCategoryName="Trending"
      userIntent={{ intent: "mixed", tagType: "general" }}
    />
    
      
    
  </div>
)}


<EndingonHomePageSection  sendClickFeed={sendClickFeed} removeClickFeed={removeClickFeed} orignalElement={orignalElement} />
<ExploreLinkButton buttonText={`Continue exploring`} buttonType="explore" forWhich={"SuggestedFeed"} />

    </div>

    
    </>
  )
    
  // Component Return Block End Here--------------------------------
   
}



export function ExploreLinkButton(props) {
  const usenavigate = useNavigate();

  function navigatePage(e) {
    // console.log("navigate click", props.category)
    // RippleEffect(e.target, e)
    // setTimeout(()=>{
      
      const safeText = (props.buttonText || "explore_button").toLowerCase().replace(/\s+/g, "_");

      const eventName = `home_explore_button_click_${safeText}`;

trackEvent(eventName, {
  page: props.componentFrom || "home",
  category: props.category || null,
  label: props.buttonText || "explore_button",
});

    // vibrateMobileDevice()
  if(props.buttonType === "blog"){

      usenavigate('/blogs')
    }else if(props.buttonType === "product"){
      usenavigate('/products')
    }else if(props.buttonType === "userchoice" && props.category){
        const safeCategory = encodeURIComponent(props.category);
      usenavigate(`/explore-next/photo/${safeCategory}`, {
        state: {
          source: "home",
          category: props.category
        }
      });


    }else if(props.buttonType === "captions" && props.buttonFor === "captions"){
        const safeCategory = encodeURIComponent(props.category);
      usenavigate(`/captions/${safeCategory}`);


    }
    else{
      // console.log("props.initialLoadedImages from ", props.initialImages, props.buttonType)
        usenavigate('/explore', {
        state: { initialExploreImages: props.initialImages }
      });
      
    }
    // }, 5000)
    
  
  }

  return (
    <div className='d-flex justify-content-center align-items-center my-4' >

    <button className="brand_button" tabIndex={0} onClick={(e)=>navigatePage(e)}    
     style={{color: "white", width: "fit-content", padding: "10px 30px 14px 30px", cursor: "pointer", borderRadius: "10px", fontWeight: 600,
      pointerEvents: "auto",
     }}> <span className='brand_button_text'>  {props.buttonText} </span><i class="fa-solid fa-angles-right icon_space"></i></button>
    </div>
  )
}

// Your feed will get better as you explore, save, and interact.


// function AppStatusElements(props) {
//   const usenavigate = useNavigate();
//   const appInfoRef = useRef()
//   const hideDiscoverlyNote = (key) => {
 
//   setTimeout(() => {
 
//     let dismissText = appInfoRef.current
//     if(dismissText){
//       dismissText.remove()
//       localStorage.setItem("hideDiscoveryNote", "true");

//     }


//   }, 220); 


// };
 

//   return (
//     <div className='d-flex justify-content-between align-items-center my-4 explore-soft-text app_status_item' ref={appInfoRef}>
// <span className="brand_button_text top_status_text_message">
// {/* Your feed will get better as you explore, save, and interact. */}
// {/* Your feed will get better on every visit as you explore... */}
// {/* Your daily mood collection — a calm space to explore and save what you love. */}
// {/* Save your daily mood collection with ready-to-use content. */}
// {/* Save, reuse, and post content you love — instantly. */}
// Find aesthetic images. Get captions & hashtags. Post instantly.





// {/* Explore a little more to unlock better picks. */}
// </span>
//   <i
//         className="fa-solid fa-xmark explore_purposetext_close home_status_close_button"
//         onClick={() => hideDiscoverlyNote()}
//       ></i>

  
//     </div>
//   )
// }

function EndingonHomePageSection(props){

  useEffect(() => {
  const el = document.querySelector(".new_app_checkmark_icon");
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
       setTimeout(()=>{
      el.classList.add("animate");
        observer.disconnect();
       }, 100)
      }
      // else{
      //     el.classList.remove("animate");
      //   observer.disconnect();

      // }
    },
    { threshold: 0.25 } 
  
  );

  observer.observe(el);
}, []);


  return(<>
    <div className='container app_container app_ending_section '>
<i class="fa-regular fa-circle-check new_app_checkmark_icon"></i>
<div className='end_message_container'>
<span className='last_updated_text'>Images updated every hours</span>

 {/* <div className='app_home_feeds_heading  app_end_heading text-center'>You can continue exploring anytime.</div> */}
 <div className='app_home_feeds_heading  app_end_heading text-center'>Find Images & Captions for Your Everyday Posts.</div> 

{/* <div class="tool_bottom_action home_bottom_action">
  <Link class="hashtags_copy_button explore_tools" tabindex="0" to="/explore">Explore Images</Link>

  <Link class="hashtags_copy_button explore_tools" tabindex="0" to="/captions/love">Explore Captions</Link>
  </div> */}

{/* <span className='last_updated_text'>come back anytime to continue where you left off</span> */}
 </div>
 {/* <Link class="app_explore_see_all app_section_endbutton"
        
          
           to={"/explore"}
           draggable={false}
            onMouseDown={(e)=> props.sendClickFeed(e)} 
            onMouseUp={(e)=> props.removeClickFeed(e)} 
            onMouseOut={(e)=>props.orignalElement(e)}
           onTouchStart={(e) => props.sendClickFeed(e)}
            onTouchEnd={(e) => props.removeClickFeed(e)}
          onTouchCancel={(e) =>props.orignalElement(e)}
          
          >Continue Exploring <i className="fa-solid fa-angle-right home_seeall_icon"></i></Link> */}





    </div>
  </>)

}
function ButtonText(){
  return(
    <>
      <span className='small_up_text'>Keep exploring</span>
    </>
  )
}

